import moment from 'moment';

export const strictFromNow = (dateStr, tz) => {
  const now = moment.tz(tz);
  const then = moment.tz(dateStr, tz);
  const duration = moment.duration(now.diff(then));

  const years = Math.floor(duration.asYears());
  const months = Math.floor(duration.asMonths());
  const days = Math.floor(duration.asDays());
  const hours = Math.floor(duration.asHours());
  const minutes = Math.floor(duration.asMinutes());

  if (years > 0) return `${years} year${years > 1 ? 's' : ''} ago`;
  if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
};

export const selectedBusinessOnTop = (businessesList, selectedBusiness) => {
  return businessesList?.data?.length && selectedBusiness?.length ?
    [
      ...selectedBusiness.map(item => ({id: item.id, attributes: {...item}})),
      ...(businessesList?.data || []).filter(item => !selectedBusiness?.some(bus => bus?.id === item?.id)),
    ] :
    [];
};
